/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

// Mixins
import saveSettings from 'ui/mixins/workspaces/save-settings';

const __vue_script__ = {
    name: 'SelfSessionCheckin',

    components: { Toggler },

    mixins: [saveSettings],

    props: {
        params: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            eid: this.params.event._id,
            innerValue: {
                pin_codes: false,
            },
            pinCodesRegenerated: false,
            regenerateInProgress: false,
            firstTimeToGeneratePinCodes: false,
            config: null,
            scope: get(this.params, 'currentController.routeOptions.settingsKey'),
        };
    },

    async created() {
        this.config = await this.$services.settings.getSetting(this.eid, this.scope);
        console.info('[SelfSessionCheckin] Settings loaded', this.config);

        if (this.config.pin_codes === undefined) {
            this.firstTimeToGeneratePinCodes = true;
        } else {
            this.innerValue.pin_codes = this.config.pin_codes;
        }
    },

    methods: {
        async forceRegeneratePinCodes(regenerateAllCodes = true) {
            this.regenerateInProgress = true;

            try {
                await this.$services.appScripts.callAppScript(this.eid, 'session-check-in/regenerate-codes', {
                    regenerateAllCodes
                });

                const successMessage = this.firstTimeToGeneratePinCodes ?
                    this.$i18n.t('self_check_in.messages.first_time_generated').toString() :
                    this.$i18n.t('self_check_in.messages.regenerate_success').toString();

                this.$notify({
                    group: 'flashes',
                    text: successMessage,
                    type: 'success',
                    duration: 5000
                });

                this.pinCodesRegenerated = true;
                this.regenerateInProgress = false;
            } catch (error) {
                console.error('[SelfSessionCheckin] Could not regenerate pin codes', error);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('self_check_in.messages.save_failure').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        },

        async saveSettings() {
            if (this.innerValue.pin_codes && this.firstTimeToGeneratePinCodes) {
                await this.forceRegeneratePinCodes(false);
            }

            this.config.pin_codes = this.innerValue.pin_codes;
            console.info('[SelfSessionCheckin] Saving settings', this.scope, this.innerValue);
            return this.save(this.eid, this.scope, this.config);
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pin-codes" },
    [
      _c("validation-observer", {
        attrs: { slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.saveSettings)
                      },
                    },
                  },
                  [
                    _c("fieldset", [
                      _c("h5", [
                        _vm._v(_vm._s(_vm.$t("self_check_in.pin_codes.intro"))),
                      ]),
                    ]),
                    _c(
                      "fieldset",
                      [
                        _c(
                          "validation-provider",
                          { attrs: { slim: true } },
                          [
                            _c("toggler", {
                              attrs: {
                                name: "pin_codes",
                                "on-label":
                                  "self_check_in.pin_codes.form.pin_codes",
                                "off-label":
                                  "self_check_in.pin_codes.form.pin_codes",
                              },
                              model: {
                                value: _vm.innerValue.pin_codes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.innerValue, "pin_codes", $$v)
                                },
                                expression: "innerValue.pin_codes",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.innerValue.pin_codes &&
                        !_vm.firstTimeToGeneratePinCodes
                          ? _c("div", { staticClass: "feature-dependant" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { staticClass: "control-label" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "self_check_in.pin_codes.form.force_regenerate_label"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary btn-icon",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.regenerateInProgress,
                                    },
                                    on: { click: _vm.forceRegeneratePinCodes },
                                  },
                                  [
                                    _vm.pinCodesRegenerated
                                      ? _c("span", [
                                          _c("i", { staticClass: "ic-check" }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "self_check_in.pin_codes.form.regenerated_btn_txt"
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _c("i", {
                                            staticClass: "ic-refresh-cw",
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "self_check_in.pin_codes.form.force_regenerate_btn_txt"
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("secondary-toolbar", [
                      _c("button", { staticClass: "btn btn-primary" }, [
                        _vm._v(_vm._s(_vm.$t("general.save"))),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/session-check-in/PinCodes.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__